// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {

  const query = `
    query (
      $id: Int,
      $title: String,
      $title_en: String,
      $title_fr: String,
      $title_it: String,
      $title_pt: String,
      $content: String,
      $content_en: String,
      $content_fr: String,
      $content_it: String,
      $content_pt: String,
    ) {
      updateBannerSettings (
        id: $id,
        title: $title,
        title_en: $title_en,
        title_fr: $title_fr,
        title_it: $title_it,
        title_pt: $title_pt,
        content: $content,
        content_en: $content_en,
        content_fr: $content_fr,
        content_it: $content_it,
        content_pt: $content_pt,
      ) {
          status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateBannerSettings.status === "success") {
    showToaster({ messageId: 'updateBannerSettings', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateBannerSettingsFailed', toasterType: 'error' })
  }

}

export default submit;
